import { render, staticRenderFns } from "./MonitorsFilter.vue?vue&type=template&id=8027643c&scoped=true"
import script from "./MonitorsFilter.vue?vue&type=script&lang=ts"
export * from "./MonitorsFilter.vue?vue&type=script&lang=ts"
import style0 from "./MonitorsFilter.vue?vue&type=style&index=0&id=8027643c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8027643c",
  null
  
)

export default component.exports